import { loadStripe } from '@stripe/stripe-js';
import { supabase } from '../lib/supabase';

const stripePublishableKey = import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  throw new Error('Missing Stripe publishable key');
}

export const stripePromise = loadStripe(stripePublishableKey);

export const createPaymentIntent = async (paymentData, customerInfo) => {
  try {
    const { data, error } = await supabase?.functions?.invoke('create-payment-intent', {
      body: {
        paymentData,
        customerInfo,
      },
    });

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error creating payment intent:', error);
    return { data: null, error };
  }
};

export const confirmPayment = async (paymentIntentId) => {
  try {
    const { data, error } = await supabase?.functions?.invoke('confirm-payment', {
      body: { paymentIntentId },
    });

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error confirming payment:', error);
    return { data: null, error };
  }
};